export default "__VITE_ASSET__xf64br9B__"